import { useEffect } from 'react';

import useCredentialTypeData from '../../state/credentialType/UseCredentialTypeData';

const useCredentialTypeDropdown = () => {
  const { credentialTypeState, getCredentialTypes } = useCredentialTypeData();

  useEffect(() => {
    if (credentialTypeState.isArrayLoading !== true && credentialTypeState.isArrayLoaded !== true) {
      getCredentialTypes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [credentialTypeState])

  return {
    credentialTypeState
  };
};

export default useCredentialTypeDropdown;